for (const form of document.querySelectorAll('form:has([data-wcs-inquiry])')) {
  form.addEventListener('invalid', (event) => {
    let details = event.target.closest('details');
    while (details) {
      details.open = true;
      details = details.parentElement.closest('details');
    }
  }, true);
  const params = new URLSearchParams(window.location.search);
  const model = params.get('model');
  const reference = form.querySelector('[data-wcs-inquiry-reference]');
  if (model && reference && !reference.value) reference.value = model.slice(0, 200);
  if (model) {
    for (const link of document.querySelectorAll('[data-wcs-installation-request]')) {
      const target = new URL(link.href);
      target.searchParams.set('model', model.slice(0, 200));
      link.href = target.href;
    }
  }
  const topics = {
    product: 'Product or compatibility question',
    order: 'Existing order or change request',
    delivery: 'Shipping or delivery',
    return: 'Return, warranty or product issue',
    'after-sales': 'Return, warranty or product issue',
    installation: 'Installation or troubleshooting help',
    payment: 'Payment or checkout help',
    feedback: 'Product feedback',
  };
  const topic = form.querySelector('select[name="contact[Question type]"]');
  const topicValue = topics[params.get('topic')];
  if (topic && !topic.value && topicValue && [...topic.options].some(option => option.value === topicValue)) {
    topic.value = topicValue;
  }
  const feedback = form.querySelector('[data-wcs-feedback]');
  const openFeedback = () => {
    if (feedback && topic?.value === 'Product feedback') feedback.open = true;
  };
  openFeedback();
  topic?.addEventListener('change', openFeedback);
}
